module.exports = __webpack_public_path__ + "img/carnet.92db723.png";